import { mixpanel, optimove, ga } from 'js/analytics/adapters'
import goalTypes from './goalTypes'
import { MALE } from 'js/genders'
import { calculateBMI } from 'js/utils'

export const trackLogin = ({ method: login_method, user }) => {
  const account_type = user.isPremium ? 'Paid' : 'Free'
  ga.track('Log In', { 'Login Method': login_method })
  mixpanel.track('Log In', { 'Login Method': login_method })

  if (user.id) {
    optimove.user({ id: String(user.id) })
  }

  if (login_method === 'Email') {
    mixpanel.people({
      userId: user.id,
      userProperties: {
        'Account Type': account_type,
      },
    })
  }

  optimove.track('log_in', {
    goal_type: goalTypes[user.goal],
    first_name: user.firstName,
    gender: user.gender === MALE ? 'Male' : 'Female',
    age: parseInt(user.age),
    weight: parseInt(user.weight),
    height: parseInt(user.height),
    goal_weight: user.goalWeight && parseInt(user.goalWeight),
    bmi: calculateBMI(user.weight, user.height),
    goal_bmi: calculateBMI(user.goalWeight, user.height),
    marketing_consent: true,
    email_validated: false,
    account_type,
    subscription_duration: user.purchaseType,
    login_method,
    user_id: user.id,
  })
}
